const KEY_PATTERN=/^[a-z][a-z0-9_]{1,47}$/;
const LEVELS=new Set(['low','medium','high','avoid','prefer']);
const SAFETY_PARTS=new Set([
  'temperature','temp','time','duration','minimum','maximum','safe','safety',
  'internal','pasteurization','haccp','pathogen','cook','cooking'
]);

function preferenceKey(value){
  const key=String(value||'').trim().toLowerCase();
  if(!KEY_PATTERN.test(key))throw new TypeError('Invalid taste preference key');
  const parts=key.split('_');
  if(parts.some(part=>SAFETY_PARTS.has(part)))throw new TypeError('Safety constraints are not taste preferences');
  return key;
}

function preferenceLevel(value){
  const level=String(value||'').trim().toLowerCase();
  if(!LEVELS.has(level))throw new TypeError('Unsupported taste preference level');
  return level;
}

export function createTastePreferences(values={}){
  if(values==null)return Object.freeze({});
  if(typeof values!=='object'||Array.isArray(values))throw new TypeError('Taste preferences must be an object');

  const entries=Object.entries(values);
  if(entries.length>20)throw new TypeError('Too many taste preferences');

  const result={};
  for(const [rawKey,rawValue] of entries){
    const key=preferenceKey(rawKey);
    result[key]=preferenceLevel(rawValue);
  }
  return Object.freeze(result);
}

export function updateTastePreference(preferences,key,value){
  const current={...createTastePreferences(preferences)};
  const resolvedKey=preferenceKey(key);
  if(value==null||value===''){
    delete current[resolvedKey];
    return createTastePreferences(current);
  }
  current[resolvedKey]=preferenceLevel(value);
  return createTastePreferences(current);
}

export function tastePreferenceContext(preferences){
  return Object.freeze({
    values:createTastePreferences(preferences),
    contextOnly:true,
    safetyConstraint:false
  });
}
